/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/resetPassword.scss';

import React, {KeyboardEventHandler, MouseEventHandler, PureComponent} from 'react';
import {ChangeFunction, Loader, preventDefault} from '@dvrd/dvr-controls';
import {ResetErrorHandler, ResetPasswordErrors} from "../../../../util/interfaces";
import PasswordStrength from "../../../password/passwordStrength";
import {BolmateButton, BolmatePasswordInput} from "../../../controls";
import Image from "../../../misc/image";

interface Props {
    onChange: (key: 'pass' | 'confirm') => ChangeFunction;
    onSubmit: MouseEventHandler & KeyboardEventHandler;
    onResetError: ResetErrorHandler<ResetPasswordErrors>;
    password: string;
    confirmPassword: string;
    loading: boolean;
    errors: ResetPasswordErrors;
}

export default class ResetPassword extends PureComponent<Props> {
    render = () => {
        const {loading, errors, confirmPassword, onChange, password, onResetError, onSubmit} = this.props;
        return (
            <div className='reset-password'>
                <div className='logo-header'>
                    <Image name='logo' className='logo'/>
                </div>
                <div style={{position: 'relative'}}>
                    <Loader active={loading}/>
                    <div className='header-container'>
                        <h1 className='header-title'>Wachtwoord opnieuw instellen</h1>
                        <label className='sub-title'>Kies een nieuw wachtwoord</label>
                    </div>
                    <form onSubmit={preventDefault} className='form'>
                        <BolmatePasswordInput value={password} onChange={onChange('pass')} label='Nieuw wachtwoord'
                                              error={errors.password} onFocus={onResetError('password')}
                                              inputProps={{
                                                  autoComplete: 'new-password',
                                                  placeholder: 'Nieuw wachtwoord'
                                              }}/>
                        <PasswordStrength value={password}/>
                        <BolmatePasswordInput value={confirmPassword} onChange={onChange('confirm')}
                                              label='Herhaal wachtwoord'
                                              error={errors.confirmPassword} onFocus={onResetError('confirmPassword')}
                                              inputProps={{
                                                  autoComplete: 'new-password',
                                                  placeholder: 'Herhaal wachtwoord'
                                              }}/>
                    </form>
                    <div className='btn-container'>
                        <BolmateButton onClick={onSubmit} label='Opslaan' disabled={loading}/>
                    </div>
                </div>
            </div>
        )
    }
}